import { HomePage, mainRoutes } from "./main";
import { Navigate, Outlet, useRoutes } from "react-router-dom";

import MainLayout from "src/layouts/main";
import { authDemoRoutes } from "./auth-demo";
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";
import { AuthConsumer, AuthProvider } from "src/auth/context/jwt";
import { ExchangeRateProvider } from "src/exchange-rate";
import { CheckoutProvider } from "src/sections/hotelCheckout/context";
import { TransferProvider } from "src/sections/transferCheckout/context";
import { FlightProvider } from "src/sections/flightCheckout/context";
import { GoogleMapsPlacesProvider } from "src/components/google-maps-places";

export default function Router() {
    return useRoutes([
        {
            path: "/",
            element: (
                <MainLayout addHeaderAndFooter={false}>
                    <GoogleMapsPlacesProvider>
                        <HomePage />
                    </GoogleMapsPlacesProvider>
                </MainLayout>
            ),
        },
        ...mainRoutes,
        {
            element: (
                <AuthProvider>
                    <ExchangeRateProvider>
                        <CheckoutProvider>
                            <TransferProvider>
                                <FlightProvider>
                                    <AuthConsumer>
                                        <Outlet />
                                    </AuthConsumer>
                                </FlightProvider>
                            </TransferProvider>
                        </CheckoutProvider>
                    </ExchangeRateProvider>
                </AuthProvider>
            ),
            children: [...authRoutes, ...authDemoRoutes, ...dashboardRoutes],
        },
        { path: "*", element: <Navigate to="/404" replace /> },
    ]);
}
